import {Outlet} from 'react-router-dom';

const img = require('../../assets/' + process.env.REACT_APP_LOGO);
const themes = {
    'khronos.png': 'bg-red-800',
    'centralarme.png': 'bg-blue-400',
}
export default function Login() {

    return (
        <>
            <div className="hidden md:block w-8/12 h-screen  float-left inline-block">
                <img className="top-2/4 left-2/4 relative -translate-x-2/4 -translate-y-2/4"
                     src={img}
                     alt="logo"
                />
            </div>
            <div className={`w-full md:w-4/12 h-screen inline-block ${themes[process.env.REACT_APP_LOGO]}`}>
                <div
                    className={`${themes[process.env.REACT_APP_LOGO]} relative top-1/2 -translate-y-1/2 content-center
                     justify-center py-12 px-4 sm:px-6 lg:px-8`}>
                    <Outlet/>
                </div>
            </div>
            <div className='bg-blue-400'></div>
        </>
    );
}